export default {
	computed: {
		cannotDeleteHasDevicesMessage() {
			return this.$gettext('Pokud chcete smazat odběratele, nejdříve odstraňte jeho zařízení.')
		}
	},
	methods: {
		getCannotDeleteHasDevicesMessage() {
			return this.cannotDeleteHasDevicesMessage
		},
		resetFields() {
			this.processErrorMessage({'validation_errors': [], 'error_message': ''})
		},
		_processDetailErrorMessage(error) {
			return this.processErrorMessage(error)
		},
		processErrorMessage(error) {
			let loginError = null
			let passwordError = null
			let surnameError = null
			let firstnameError = null
			let maxPairedDeviceCountError = null
			let maxTestingSubscriberCountError = null
			let lockPinError = null
			let countryError = null
			let macAddressError = null

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Subscriber with given login name') &&
					this._.includes(errorMessage, 'already exists inside current brand.')) {
					loginError = this.$gettext('Zadaný login se již v brandu používá')
				} else if (this._.includes(errorMessage, 'Password was given, login was not.')) {
					loginError = this.$gettext('Zadejte login')
				} else if (errorMessage === 'Subscriber\'s login is too short - at least 2 letters are required.') {
					loginError = this.$gettext('Login musí obsahovat min. 2 znaky')
				}

				if (errorMessage === 'Subscriber\'s password must be at least 4 letters.') {
					passwordError = this.$gettext('Heslo musí obsahovat min. 4 znaky')
				} else if (this._.includes(errorMessage, 'Login was given, password was not.')) {
					passwordError = this.$gettext('Zadejte heslo')
				}

				if (errorMessage === 'Subscriber\'s surname is missing.') {
					surnameError = this.$gettext('Zadejte příjmení')
				} else if (errorMessage === 'Subscriber\'s surname is too short - 2 letters at least are required.') {
					surnameError = this.$gettext('Příjmení musí obsahovat min. 2 znaky')
				}

				if (errorMessage === 'Subscriber\'s firstname is missing.') {
					firstnameError = this.$gettext('Zadejte jméno')
				} else if (errorMessage === 'Subscriber\'s firstname is too short - 2 letters at least are required.') {
					firstnameError = this.$gettext('Jméno musí obsahovat min. 2 znaky')
				}

				if (this._.includes(errorMessage, 'Subscriber\'s maximum number of devices and/or pairing codes') &&
					this._.includes(errorMessage, 'must not be lowered bellow current number of devices')) {
					maxPairedDeviceCountError = this.$gettext('Limit počtu spárovaných zařízení nesmí být nižší než aktuální počet zařízení')
				} else if (errorMessage === 'Maximum paired device count must be at least 1.') {
					maxPairedDeviceCountError = this.$gettext('Limit počtu spárovaných zařízení musí být větší než 0')
				} else if (errorMessage === 'Subscriber\'s maximum number of devices must be number.') {
					maxPairedDeviceCountError = this.$gettext('Limit počtu spárovaných zařízení musí být celé číslo')
				}

				if (errorMessage === 'Preprovisioned device must have a mac address set.') {
					macAddressError = this.$gettext('Přednastavené zařízení musí mít vyplněnou MAC adresu.');
				}else if(errorMessage === 'Device can\'t be preprovisioned because of mac addresses are assigned to another device.'){
					macAddressError = this.$gettext('Zařízení nemůže být nastaveno jako přednastavené, protože jedna z jeho MAC adres je již přiřazena jinému zařízení.');
				}

				if (this._.includes(errorMessage, 'Mac address') && this._.includes(errorMessage, 'is not unique.')) {
					macAddressError = this.$gettext('Zadaná MAC adresa není unikátní.')
					error['error_message'] = this.$gettext('Zadaná MAC adresa není unikátní.')
				}

				if (this._.includes(errorMessage, 'Subscriber\'s maximum number of devices') &&
					this._.includes(errorMessage, 'was exceeded.')) {
					error['error_message'] = this.$gettext('Odběratel dosáhl limitu počtu zařízení.')
				}

				if (errorMessage === 'Subscriber\'s parental lock pin must be 4 digits number.') {
					lockPinError = this.$gettext('Rodičovský zámek musí obsahovat 4 číslice')
				}

				if (errorMessage === 'Subscriber\'s country - Not a valid country (using codes from ISO 3166-1 alpha-3).') {
					countryError = this.$gettext('Chybný kód státu.')
				}

				if (this._.includes(errorMessage, 'Operator\'s maximum number of testing subscribers') &&
					this._.includes(errorMessage, 'has exceeded.')) {
					error['error_message'] = this.$gettext('Počet testovacích odběratelů dosáhl limit.')
					maxTestingSubscriberCountError = true
				}

				if (this._.includes(errorMessage, 'active devices')) {
					error['error_message'] = this.getCannotDeleteHasDevicesMessage()
				}
			}.bind(this))

			let root = null
			if(this.$route.name === 'subscriberDetailSettings') {
				root = this.$refs['subscriberDetailSettings']
			} else if(this.$route.name === 'subscriberNew') {
				root = this
			}

			if(!root) {
				return error['error_message']
			}

			if (loginError !== null) {
				root.$refs['settingsref'].setLoginInvalid(true, loginError)
			} else {
				root.$refs['settingsref'].setLoginInvalid()
			}

			if (passwordError !== null) {
				root.$refs['settingsref'].setPasswordInvalid(true, passwordError)
			} else {
				root.$refs['settingsref'].setPasswordInvalid()
			}

			if (surnameError !== null) {
				root.$refs['basicinforef'].$refs['surnameref'].setForcedInvalid(true, surnameError)
			} else {
				root.$refs['basicinforef'].$refs['surnameref'].setForcedInvalid()
			}

			if (firstnameError !== null) {
				root.$refs['basicinforef'].$refs['firstnameref'].setForcedInvalid(true, firstnameError)
			} else {
				root.$refs['basicinforef'].$refs['firstnameref'].setForcedInvalid()
			}

			if (error['error_message'] === 'Invalid request format: Invalid value for maximum paired device count') {
				maxPairedDeviceCountError = this.$gettext('Limit počtu spárovaných zařízení musí být celé kladné číslo')
			}

			if (maxPairedDeviceCountError !== null) {
				root.$refs['settingsref'].$refs['maximumpaireddevicecountref'].setForcedInvalid(true, maxPairedDeviceCountError)
			} else {
				root.$refs['settingsref'].$refs['maximumpaireddevicecountref'].setForcedInvalid()
			}

			if (maxTestingSubscriberCountError !== null) {
				root.$refs['settingsref'].$refs['subscriptiontyperef'].setForcedInvalid(true)
			} else {
				root.$refs['settingsref'].$refs['subscriptiontyperef'].setForcedInvalid()
			}

			if (lockPinError !== null) {
				root.$refs['settingsref'].$refs['parentallockpinref'].setForcedInvalid(true, lockPinError)
			} else {
				root.$refs['settingsref'].$refs['parentallockpinref'].setForcedInvalid()
			}

			if (countryError !== null) {
				root.$refs['contactref'].$refs['statref'].setForcedInvalid(true, countryError)
			} else {
				root.$refs['contactref'].$refs['statref'].setForcedInvalid()
			}

			if (macAddressError !== null) {
				this.$refs['subscriberDetailDevices'].$refs['devicesref'].$refs['newdevicemacaddressref'].setForcedInvalid(true, macAddressError)
				error['error_message'] = macAddressError;
			}

			return error['error_message']
		},
		processSubscriberServiceErrorMessage(error) {
			let finalMessage = ''
			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Error when saving subscriber service relationship') &&
					this._.includes(errorMessage, 'has different business model than the subscriber')) {
					finalMessage += this.$gettext('Business model služby musí být stejný jako business model odběratele.')
				}
				if (this._.includes(errorMessage, 'do not allow combination with other packages')) {
					finalMessage += this.$gettext('Vybrané služby obsahují balíčky, které se nemůžou kombinovat.')
				}
				if (this._.includes(errorMessage, 'You must first add "basic" channel package')) {
					finalMessage += this.$gettext('Nelze přiřadit tematické balíčky. Nejdřív musíte přiřadit službu se základním balíčkem a povolit kombinaci s tematickým.')
				}
			}.bind(this))

			if (this._.includes(error['error_message'], 'Cannot remove this service. Remaining packages are not allowed to be without basic package')) {
				finalMessage += this.$gettext('Nelze smazat službu. Zbývající tematické balíčky nemůžou zůstat bez základního balíčku, který umožňuje kombinaci s tematickými.')
			}

			if (finalMessage === '') {
				finalMessage = error['error_message']
			}

			return finalMessage
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/subscribers/mixins/subscribers.js